/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
// hooks
import api from "@src/utils";
import { useAppDispatch, useAppSelector } from "@src/app/hooks";
// packages
import { Group, PinInput } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";
import { notification } from "antd";
import { useMutation } from "@tanstack/react-query";
// components
import apiLinks from "@src/apiLinks";
import { Button } from "@components/Button/Button";
import { authenticate } from "@src/features/userSlice";
import va from "@vercel/analytics";
import apiRoutes from "@/src/apiRoutes";
import { toast } from "sonner";

const OTPLogin = () => {
  const { lastPath } = useAppSelector((state) => state.user);
  const [otp, setOtp] = useState("");
  const [, setResendToken] = useState("");
  const { state: token } = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { state } = useLocation();

  // function to submit otp
  const submitOtp = async (e: React.FormEvent) => {
    e.preventDefault();
    const res = await api.post(apiRoutes.login2fa, {
      ...state,
      code: otp,
      token: state?.token,
    });
    return res.data;
  };

  const { mutate, isLoading } = useMutation({
    mutationKey: ["otp_submit"],
    mutationFn: submitOtp,
    onSuccess: (data) => {
      if (data?.success) {
        if (data.token) {
          navigate("/auth/confirm_otp", { replace: true, state: data.token });
        } else {
          va.track("login");
          // toast.success("");
          navigate(lastPath ?? "/app/home");
          dispatch(authenticate(data.info));
        }
      } else {
        toast.error(data?.info);
      }
    },
    onError: (error: any) => {
      if (error?.response?.data) {
        notification.error({ message: error?.response?.data });
      }
    },
  });

  // Function to resend otp
  const resend = async (e: React.FormEvent) => {
    e.preventDefault();
    const res = await api.post(apiLinks.resetEndpoint, {
      type: "resend_login_otp",
      token: token,
    });

    return res?.data;
  };

  const { mutate: resendOtp, isLoading: resendLoad } = useMutation({
    mutationKey: ["resend_otp"],
    mutationFn: resend,
    onSuccess: (data) => {
      setResendToken(data?.token);
      if (data?.success) {
        notification.success({
          message: "Success",
          description: "OTP has been resent",
        });
      } else {
        notification.warning({
          message: "oops!",
          description: data?.info,
        });
        navigate("/");
      }
    },
  });

  return (
    <form>
      <p className="text-sm  text-gray-500 my-4">
        Enter the one-time password sent to your mail or received on your phone
      </p>
      <Group position="center">
        <PinInput
          type={"number"}
          value={otp}
          onChange={setOtp}
          size={"xl"}
          length={6}
        />
      </Group>
      <div className="flex items-center justify-center mt-5">
        <Button
          onClick={mutate}
          loading={isLoading}
          type={"submit"}
          // title={"Submit"}
          variant={"primary"}
        >
          Submit
        </Button>
      </div>
      <div className="w-2/3 flex items-center justify-center mx-auto mt-2 text-sm  text-gray-500">
        {!resendLoad ? (
          <span onClick={resendOtp} className="cursor-pointer ">
            Resend One-Time Password
          </span>
        ) : (
          <span className="text-sm  text-gray-500">Loading...</span>
        )}
      </div>
    </form>
  );
};

export default OTPLogin;
